module.exports = __webpack_public_path__ + "img/blog2.d12c3847.svg";